export default [
  {
    path: '/student-galleries',
    name: 'student-gallery',
    meta: { requiresAuth: true },
    component: () => import('@/pages/student-gallery/index.vue')
  }
]
